import * as actions from "../redux/action_creators"
import { put, call } from "redux-saga/effects"
import { makeToast } from "./toast_util"

export function* ingressAccountAndValidCustomer(account) {
    yield put(actions.receiveAccounts(account))

    const { customer } = account

    if (account.customerId && !customer){
        yield call(
            makeToast,
            "Something went wrong finding a customer",
            "warning",
        )
    }

    if (!!account.customerId && !!customer) {
        yield put(actions.receiveCustomer(customer))
    }
}


// WEBPACK FOOTER //
// ./src/util/account_customer_utils.js